import React from 'react';
import { PasskeySetupDialog } from '../Profile/ProfileAuthentication/Passkeys/PasskeySetupDialog';
import { AuthenticatorAppSetupDialog } from '../Profile/ProfileAuthentication/AuthenticatorApp/AuthenticatorAppSetupDialog';

export const InternalRouterGlobalComponents = () => {
  return (
    <React.Fragment>
      <PasskeySetupDialog />
      <AuthenticatorAppSetupDialog />
    </React.Fragment>
  );
};
